import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../../action';
import * as c from '../../../constant';
import ViewOrModal from '../modals/ViewOrModal';
// import PaymentHistoryModal from '../modals/PaymentHistoryModal';
import ViewPaymentInformationModal from '../modals/ViewPaymentInformationModal';

function PaymentHistory({
  paymentHistoryList,
  getPaymentHistoryList,
  // getActualUseList,
  // actualUseList,
  isLoading,
  applicationId,
  // applicationInfo,
}) {
  const setModal = useContext(ModalContext);

  const handleViewOrModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOrModal data={data} applicationId={applicationId} />,
      title: 'View OR',
      modalSize: 'modal-xl',
    });
  };

  const handleViewPaymentInformationModal = () => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewPaymentInformationModal applicationId={applicationId} />,
      title: 'View Payment Information',
      modalSize: 'modal-xl',
    });
  };

  // const handleAddPaymentHistory = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <PaymentHistoryModal
  //         applicationId={applicationId}
  //         actualUseList={actualUseList}
  //         applicationInfo={applicationInfo}
  //       />
  //     ),
  //     title: 'Add Payment History',
  //     modalSize: 'modal-lg',
  //   });
  // };

  // useEffect(() => {
  //   getActualUseList({ status: 1 });
  // }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getPaymentHistoryList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getPaymentHistoryList(applicationId);
  }, [applicationId]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <div className="col-12 d-flex">
                <div className="ml-auto mb-2">
                  {paymentHistoryList.length > 0 && (
                    <button
                      onClick={handleViewPaymentInformationModal()}
                      type="button"
                      className="btn btn-primary cms-bg-color-primary-light cms-text-primary mr-2"
                    >
                      View Payment Information
                    </button>
                  )}
                  {/* {['CANCELLED'].indexOf(
                    _.get(applicationInfo, 'attributes.status')
                  ) <= -1 && (
                    <button
                      onClick={handleAddPaymentHistory}
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                    >
                      Add Payment History
                    </button>
                  )} */}
                </div>
              </div>
              <table className="css-table table table-borderless table-sm table-light">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Status</td>
                    <td className="font-weight-bold">Period</td>
                    <td className="font-weight-bold">OR Number</td>
                    <td className="font-weight-bold">Date Paid</td>
                    <td className="font-weight-bold">Action</td>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistoryList && paymentHistoryList.length <= 0 && (
                    <tr className="text-center">
                      <td className="history-color" colSpan="7">
                        No data
                      </td>
                    </tr>
                  )}
                  {paymentHistoryList &&
                    paymentHistoryList.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.status')}
                          </span>
                        </td>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.period')}
                          </span>
                        </td>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.e_or_no')}
                          </span>
                        </td>
                        <td>
                          <span style={{ color: '#65676b' }}>
                            {_.get(item, 'attributes.date_paid')}
                          </span>
                        </td>
                        {_.get(item, 'attributes.is_manual') !== 1 && (
                          <td>
                            <button
                              onClick={handleViewOrModal(item)}
                              type="button"
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                            >
                              View OR
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

PaymentHistory.defaultProps = {
  applicationId: '',
};

PaymentHistory.propTypes = {
  paymentHistoryList: PropTypes.instanceOf(Array).isRequired,
  // applicationInfo: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getPaymentHistoryList: PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  // getActualUseList: PropTypes.instanceOf(Function).isRequired,
  // actualUseList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  paymentHistoryList: _.get(api, `${c.GET_PAYMENT_HISTORY}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PAYMENT_HISTORY) > -1,
  // actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PaymentHistory);
